import React from 'react';
import { header } from 'constants/table';
import {ThongKeBaoCao} from 'api';
import DataTable from 'components/data-table';
import {Text,InputListDropDown} from 'components/tt-forms/common';
import {ContainerFileDinhKem} from 'components/upload';
import {browserHistory} from 'react-router';
import { Button } from '@blueprintjs/core';
import {ConfirmDialog} from 'modules/dialog';
import { msg } from "constants/message";
import {ShowIf} from 'components/utils';
import { API_URL } from 'constants/config';
import { Link } from 'react-router';
import TableKetQuaPhongChongThamNhung from './TableKetQuaPhongChongThamNhung.jsx';
import {
  RowItemCongTacQuanLyNhaNuoc,
  ListItemThongKeTiepCongDan,
  ListItemThongKeGQDKN,
  ListItemThongKeGQDTC,
  ListItemThongKeXuLyDon,
  ListItemThongKeThanhTraHanhChinh,
  ListItemThongKeThanhTraXayDungCoBan,
  ListItemThongKeThanhTraDatDai,
  ListItemThongKeThanhTraChuyenNganh,
  ListItemThongKeThanhTraLai,
  ListItemThongKeThanhTraXayTaiChinhNganSach,
  ListItemThongKeThanhTraThamNhung,
  RowItemXayDungLucLuongThanhTra,
  RowItemCongTacQuanLyNhaNuocKNTC,
  RowItemTongHopKeKhai
} from './datatable';
import { Toastr } from 'modules/toastr';
import moment from 'moment';
import { isEmpty } from 'lodash';

class LapBaoCaoDinhKyPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      dataDelete: [],
      loaiBaoCao: [],
      tableLoading: false,
      update: false,
      showFile: false,
      listTaiLieuBaoCao: [],
      listTaiLieuVanThu: [],
      listTaiLieuVanThuShow: [],
      dataFileDinhKem: [],
      dataFileDinhKemDelete: [],
      thongTinBaoCao: {},
      headerTable: [],
      donViConsInfo: [],
      trangThaiBaoCao: '',
      baoCaoDonViChiTietId: '',
      hasChange: false,
      backConfirm: false,
      checkComponent: false,
      numberColumnHeader: 40,
      convertData: false,
      openDialog: false,
      dataSum: {donVi: {id: 'DATA_SUM'}},
      dataDonTrung: {},
      dataOption: [],
      popupChotBaoCao: false,
      ngayKetThucBC: '',
      readOnly: false
    }
  }

  componentDidMount() {
    this.getDataLapBaoCaoDinhKyChiTiet(this.props.params.id);
    this.getLapBaoCaoDinhKyChiTiet(this.props.params.id);
    this.getDonViLapBaoCaoDinhKy();
  }

  getDonViLapBaoCaoDinhKy() {
    ThongKeBaoCao.actions.getDonViLapBaoCaoDinhKy.request().then(res => {
      if(res.data._embedded) {
        this.setState({
          dataOption: res.data._embedded.coQuanQuanLies
        })
      }
    })
  }

  getDataLapBaoCaoDinhKyChiTiet(id) {
    ThongKeBaoCao.actions.getDataLapBaoCaoDinhKyChiTiet.request({idBaoCaoDonViChiTiet: id}).then(res => {
      if (res.data && res.data._embedded) {
        let data = [...res.data._embedded.baoCaoDonViChiTietTams];
        let newData = [];
        let dataDonTrung = {};
        data.map(item => {
          let itemDetail = item.soLieuBaoCaoInfo || {};
          itemDetail.donVi = {
            id: item.baoCaoDonViChiTietInfo ? item.baoCaoDonViChiTietInfo.donViId : null,
            ten: item.soLieuBaoCaoInfo ? item.soLieuBaoCaoInfo.tenDonVi : ''
          }
          itemDetail.id = item.baoCaoDonViChiTietTamId;
          dataDonTrung = itemDetail.soLieuTrung;
          newData.push(itemDetail);
        })
        if(data.length > 0) {
          this.state.chaID = data[0].baoCaoDonViChiTietInfo ? data[0].baoCaoDonViChiTietInfo.chaId : '';
        }
        this.setState({
          data : newData,
          dataDonTrung
        })
        this.checkSum(newData);
      }
    })
  }

  CheckNullObj(obj) {
    let newObj = {...obj};
    delete newObj['donVi'];
    delete newObj['addNew'];
    delete newObj['id'];
    for (var member in newObj) {
      if (newObj[member] != null && newObj[member] != 0 && newObj[member] != '') {
        return false;
      }
    }
    return true;
  }

  checkSum(arr) {
    if(arr.length > 0) {
      let newObj = arr[0];
      let dataSum = {
        donVi: {
          id: 'DATA_SUM',
          ten: 'dataSum'
        }
      }
      for (var member in newObj) {
        if (member != 'id' && member != 'donVi' && member != 'tenDonVi' && member != 'ghiChu') {
          let sum = this.checkSumElement(arr, member);
          dataSum[member] = sum;
        }
      }
      this.setState({
        dataSum: dataSum
      })
    }
  }

  checkSumElement(arr, field) {
    let sum = 0;
    if(arr.length > 0) {
      arr.map(item => {
        if (!isEmpty(item.soLieuTrung)) {
          sum = sum + Number(item[field]) - Number(item.soLieuTrung[field]);
        } else {
          sum = sum + Number(item[field]);
        }
      })
    }
    return sum;
  }

  getLapBaoCaoDinhKyChiTiet(id) {
    ThongKeBaoCao.actions.getLapBaoCaoDinhKyChiTiet.request({id:id}).then(res => {
      if(res.data) {
        let data = res.data;
        data.listTaiLieuBaoCao = data.listTaiLieuBaoCao.map(item => {
          return item = {
            ...item,
            soQuyetDinh: item.soVanBan,
            ngayQuyetDinh: item.ngayRaVanBan
          }
        });
        let donViConsInfo = [];
        this.state.baoCaoDonViChiTietId = data.baoCaoDonViChiTietId ? data.baoCaoDonViChiTietId : '';
        this.state.trangThaiBaoCao = data.trangThaiBaoCao ? data.trangThaiBaoCao : '';
        this.state.listTaiLieuBaoCao = data.listTaiLieuBaoCao ? data.listTaiLieuBaoCao : [];
        data.donViConsInfo.map(item => {
          let newItem = {
            ten: item.ten,
            coQuanQuanLyId: item.donViId
          }
          donViConsInfo.push(newItem)
        })
        this.state.ngayKetThucBC = data.baoCaoDonViInfo && data.baoCaoDonViInfo.ngayKetThucBC ? data.baoCaoDonViInfo.ngayKetThucBC : '';
        this.state.donViConsInfo = donViConsInfo;
        this.state.thongTinBaoCao = data.thongTinBaoCaoInfo ? data.thongTinBaoCaoInfo : {};
        this.state.tenBaoCao = data.loaiBaoCaoInfo ? data.loaiBaoCaoInfo.ten : '';
        this.state.nameRowItem = data.loaiBaoCao ? data.loaiBaoCao : '';
        this.state.readOnly = (data.baoCaoDonViInfo && data.baoCaoDonViInfo.trangThaiBaoCaoInfo && data.baoCaoDonViInfo.trangThaiBaoCaoInfo.giaTri == 'DA_GUI') || data.baoCaoDonViInfo.trangThaiBaoCaoInfo.giaTri == 'KHOA_BAO_CAO';
      }
      this.setState({
        ...this.state
      }, () => {
        if (!this.state.readOnly) {
          this.checkFileRequire();
        } else {
          this.setState({listTaiLieuVanThuShow: this.state.listTaiLieuBaoCao,showFile: true});
        }
      })
    })
  }

  checkFileRequire() {
    let data = [...this.state.listTaiLieuBaoCao];

    let dataFilter = data.filter(state => {
      return state.typeRequired == 'BCDK_TLVT'
    })

    if(dataFilter.length > 0) {
      let dataOld = [...this.state.listTaiLieuBaoCao];
      let newData = [];
      dataOld.map(item => {
        let newItem = {
          ten: item.ten,
          soQuyetDinh: item.soVanBan,
          required: item.required,
          typeRequired: item.typeRequired,
          tenFile: item.tenFile,
          taiLieuVanThuId: item.taiLieuBaoCaoId,
          ngayQuyetDinh: item.ngayRaVanBan,
          duongDan: item.urlFile
        }
        newData.push(newItem);
      })
      this.state.listTaiLieuVanThu = newData;
      this.state.showFile = true;
    } else {
      let dataOld = [...this.state.listTaiLieuBaoCao];
      let newData = [];
      dataOld.map(item => {
        let newItem = {
          ten: item.ten,
          soQuyetDinh: item.soVanBan,
          required: item.required,
          typeRequired: item.typeRequired,
          tenFile: item.tenFile,
          taiLieuVanThuId: item.taiLieuBaoCaoId,
          ngayQuyetDinh: item.ngayRaVanBan,
          duongDan: item.urlFile
        }
        newData.push(newItem);
      })

      let itemRequired = {
        ten: 'Văn bản báo cáo',
        soQuyetDinh: '',
        ngayQuyetDinh: '',
        tenFile: '',
        duongDan: '',
        progress: 0,
        required: true,
        typeRequired: 'BCDK_TLVT',
        newFile: true
      }
      this.state.listTaiLieuVanThu = [
        ...newData,
        itemRequired
      ]
      this.state.showFile = true;
    }
    this.setState({
      ...this.state
    })
  }

  onFileChange(data) {
    this.setState ({
      dataFileDinhKem: data,
      hasChange: true
    });
  }

  onFileRemove(id, data) {
    this.state.dataFileDinhKemDelete = [
      ...this.state.dataFileDinhKemDelete,
      id
    ];
    this.state.dataFileDinhKem = data;
    this.state.hasChange = true;
    this.forceUpdate();
  }

  handleBack(allowBack) {
    if (allowBack == true || this.state.readOnly) {
      browserHistory.goBack();
    } else {
      if (this.state.hasChange) {
        this.setState({backConfirm: true});
      } else {
        browserHistory.goBack();
      }
    }
  }

  closeConfirmBack() {
    this.setState({backConfirm:false});
  }

  guiBaoCao(type) {
    if(type == 'export' || this.validateSubmitForm()) {
      this.pushTaiLieuDinhKem();
      let paramsPost = this.getParams('POST');
      let paramsPatch = this.getParams('PATCH');
      this.checkDelete(paramsPost, paramsPatch, type, () => {
        this.checkCreate(paramsPost, paramsPatch, type, () => {
          this.checkEdit(paramsPatch, type, () => {
            if (type == 'export') {
              let URL = API_URL + "/baoCaoDonViChiTietTams/xuatExcel?"
              + "idBaoCaoDonViChiTiet=" + Number(this.props.params.id);
              window.open(URL, "_self");
            }
          })
        })
      });

      if(paramsPost.length == 0 && paramsPatch.length == 0 && this.state.dataDelete.length == 0) {
        if(type != 'export') {
          this.handleBack(true);
        }
        Toastr(msg.dkLuuHoSo, 'success');
      }
    }
  }

  checkDelete(paramsPost, paramsPatch, type, callBack) {
    if(this.state.dataDelete.length > 0) {
      let params = {
        baoCaoDonViChiTietTams: [
          ...this.state.dataDelete
        ]
      }
      ThongKeBaoCao.actions.deleteBaoCao.request('', params).then(res => {
        if(paramsPost.length == 0 && paramsPatch.length == 0) {
          if(type != 'export') {
            this.handleBack(true);
          }
          callBack()
          Toastr(msg.dkLuuHoSo, 'success');
        } else {
          callBack()
        }
      }).catch(err => {
        callBack()
      })
    } else {
      callBack()
    }
  }

  checkCreate(paramsPost, paramsPatch, type, callBack) {
    if(paramsPost.length > 0) {
      let params = {
        baoCaoDonViChiTietTams: [
          ...paramsPost
        ]
      }
      ThongKeBaoCao.actions.postBaoCao.request('', params).then(res => {
        if(paramsPatch.length == 0) {
          if(type != 'export') {
            this.handleBack(true);
          }
          callBack()
          Toastr(msg.dkLuuHoSo, 'success');
        } else {
          callBack()
        }
        this.getDataLapBaoCaoDinhKyChiTiet(this.props.params.id);
      }).catch(err => {
        callBack()
      })
    } else {
      callBack()
    }
  }

  checkEdit(paramsPatch, type, callBack) {
    if(paramsPatch.length > 0) {
      let params = {
        baoCaoDonViChiTietTams: [
          ...paramsPatch
        ]
      }
      ThongKeBaoCao.actions.patchBaoCao.request('', params).then(res => {
        if(type != 'export') {
          this.handleBack(true);
        }
        callBack()
        Toastr(msg.dkLuuHoSo, 'success');
      }).catch(err => {
        callBack()
      })
    } else {
      callBack()
    }
  }

  pushTaiLieuDinhKem() {
    let dataFileDinhKem = [...this.state.dataFileDinhKem];
    let taiLieuVanThuUpdate = [];
    let taiLieuVanThu = [];
    let taiLieuVanThuDelete = [];
    if (dataFileDinhKem.length > 0) {
      dataFileDinhKem.map((item, i) => {
        if (item.taiLieuVanThuId) {
          taiLieuVanThuUpdate = [...taiLieuVanThuUpdate, {
            baoCaoDonViChiTiet: {
              id: Number(this.props.params.id)
            },
            id: item.taiLieuVanThuId,
            ten: item.ten,
            soVanBan: item.soQuyetDinh,
            ngayRaVanBan: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
            tenFile: item.tenFile,
            urlFile: item.duongDan,
            required: item.required,
            typeRequired: item.typeRequired ? item.typeRequired : ''
          }];
        } else {
          taiLieuVanThu = [...taiLieuVanThu, {
            baoCaoDonViChiTiet: {
              id: Number(this.props.params.id)
            },
            ten: item.ten,
            soVanBan: item.soQuyetDinh,
            ngayRaVanBan: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
            tenFile: item.tenFile,
            urlFile: item.duongDan,
            required: item.required,
            typeRequired: item.typeRequired ? item.typeRequired : ''
          }];
        }
      });
    }

    if (this.state.dataFileDinhKemDelete.length > 0) {
      this.state.dataFileDinhKemDelete.map(item => {
        taiLieuVanThuDelete = [...taiLieuVanThuDelete, {
          id: item
        }];
      });
    }

    if(taiLieuVanThu.length > 0) {
      let params = {
        taiLieuBaoCaos: taiLieuVanThu
      }
      this.postTaiLieuVanThu(params);
    }

    if(taiLieuVanThuUpdate.length > 0) {
      let params = {
        taiLieuBaoCaos: taiLieuVanThuUpdate
      }
      this.updateTaiLieuVanThu(params);
    }

    if(taiLieuVanThuDelete.length > 0) {

      let params = {
        taiLieuBaoCaos: taiLieuVanThuDelete
      }
      this.deleteTaiLieuVanThu(params);
    }
    this.setState({dataFileDinhKem: []});
  }

  updateTaiLieuVanThu(params) {
    ThongKeBaoCao.actions.updateTaiLieuDinhKem.request('', params).then(res => {
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  postTaiLieuVanThu(params) {
    ThongKeBaoCao.actions.postTaiLieuDinhKem.request('', params).then(res => {
      if (res.data) {
        this.getLapBaoCaoDinhKyChiTiet(this.props.params.id);
      }
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  deleteTaiLieuVanThu(params) {
    ThongKeBaoCao.actions.deleteTaiLieuDinhKem.request('', params).then(res => {
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  getParams(type) {
    let data = [...this.state.data];
    if(type == 'POST') {
      let dataPost = [];
      let dataPostFilter = data.filter(state => {
        return state.addNew == true
      })
      dataPostFilter.map(state => {
        if(this.CheckNullObj(state)) {
          // do nothing
        } else {
          let item = {
            baoCaoDonViChiTiet: {
              cha: {
                id: Number(this.state.chaID)
              },
              trangThaiBaoCao: this.state.trangThaiBaoCao ? this.state.trangThaiBaoCao : null,
              loaiBaoCao: this.state.nameRowItem ? this.state.nameRowItem : null
            },
            soLieuBaoCao: {...state}
          }

          if(state.donVi.id) {
            item.baoCaoDonViChiTiet.donVi = {
              id: state.donVi.id
            }
          }
          delete item.soLieuBaoCao['donVi'];
          delete item.soLieuBaoCao['addNew'];
          dataPost.push(item)
        }
      })

      return dataPost;
    } else {
      let dataPatch = [];
      let dataPatchFilter = data.filter(state => {
        return state.addNew != true
      })
      dataPatchFilter.map(state => {
        if(this.CheckNullObj(state)) {
          let itemDelete = {
            id: state.id
          }
          this.state.dataDelete.push(itemDelete);
        } else {
          let item = {
            baoCaoDonViChiTiet: {
              cha: {
                id: Number(this.state.baoCaoDonViChiTietId)
              },
              trangThaiBaoCao: this.state.trangThaiBaoCao ? this.state.trangThaiBaoCao : null,
              loaiBaoCao: this.state.nameRowItem ? this.state.nameRowItem : null
            },
            soLieuBaoCao: {...state}
          }
          if(state.id) {
            item.baoCaoDonViChiTietTamId = state.id
          }
          if(state.donVi.id) {
            item.baoCaoDonViChiTiet.donVi = {
              id: state.donVi.id
            }
          }
          delete item.soLieuBaoCao['donVi'];
          delete item.soLieuBaoCao['addNew'];
          delete item.soLieuBaoCao['id'];
          dataPatch.push(item)
        }
      })
      return dataPatch;
    }
  }

  onChange(name,e) {}

  onAddItem(id) {
    let params = {
      idBaoCaoDonViChiTiet: this.props.params.id,
      idDonVi: id
    }
    ThongKeBaoCao.actions.getItemHeThongLapBaoCaoDinhKyChiTiet.request(params).then(res => {
      if(res.data) {
        let item = res.data;
        let newItem = item.soLieuBaoCaoInfo;
        newItem.donVi = {
          id: item.baoCaoDonViChiTietInfo.donViId,
          ten: item.soLieuBaoCaoInfo.tenDonVi
        }
        newItem.addNew = true;
        this.setState({
          data: [
          ...this.state.data,
          newItem
          ]
        }, () => {
          this.checkSum(this.state.data)
        })
      }
    })
    this.setState({
      hasChange: true
    })
  }

  addNewItem() {
    let params = {
      idBaoCaoDonViChiTiet: this.props.params.id
    }
    ThongKeBaoCao.actions.getItemHeThongLapBaoCaoDinhKyChiTiet.request(params).then(res => {
      if(res.data) {
        let item = res.data;
        let newItem = item.soLieuBaoCaoInfo;
        newItem.donVi = {
          id: null,
          ten: ''
        }
        newItem.addNew = true;
        this.setState({
          data: [
          ...this.state.data,
          newItem
          ]
        })
      }
    })
    this.setState({
      hasChange: true
    })
  }

  onRemoveItem(id) {
    let data= [...this.state.data];
    let index = data.findIndex(x => x.donVi.id == id);
    if(index != -1) {
      let itemDelete = {
        id: data[index].id
      }
      this.state.dataDelete.push(itemDelete);
      data.splice(index, 1)
      this.state.data = data;
      this.setState({
        ...this.state
      }, () => {
        this.checkSum(this.state.data)
      })
    }
    this.setState({
      hasChange: true
    })
  }

  onChangeHeader(index, e) {
    this.state.data[index].tenDonVi = e.target.value;
    this.state.data[index].donVi = {
      id: null,
      ten: e.target.value
    }
    this.state.hasChange = true;
    this.setState({
      ...this.state
    })
  }

  onItemChange(index, data) {
    this.state.data[index] = {
      ...this.state.data[index],
      ...data};
    this.state.hasChange = true;
    this.setState({
      ...this.state
    }, () => {
      this.checkSum(this.state.data)
    })
  }

  reciveData(data) {
    this.state.data = data;
    this.state.hasChange = true;
    this.setState({
      ...this.state
    }, () => {
      this.checkSum(this.state.data)
    });
  }

  exportExcel(type) {
    if (type == 'export') {
      this.setState({
        openDialog: false,
        hasChange: false
      });
      this.guiBaoCao('export');
      this.setState({popupChotBaoCao: true});
    } else if(this.state.hasChange == true) {
      this.setState({
        openDialog: true
      })
    } else {
      this.guiBaoCao('export');
      this.setState({popupChotBaoCao: true});
    }
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if (pass)
        pass = validator.validate();
      else
        validator.validate();
    });
    return pass;
  }

  closeDialog(name) {
    this.setState({
      [name]: false
    })
  }

  chotBaoCao(inputId) {
    ThongKeBaoCao.actions.patchChotSoLieuDonVi.request({id: inputId}).then(res => {
      this.closeDialog('popupChotBaoCao');
    });
  }

  render() {
    let ngayChot = moment().format('DD/MM/YYYY');
    if (this.state.ngayKetThucBC && moment().date() > moment(this.state.ngayKetThucBC).date()) {
      ngayChot = moment(this.state.ngayKetThucBC).format('DD/MM/YYYY');
    }
    return (
      <div className="center reception-container wrap-block" ref='thongKeBaoCao'>
        <div className="back-foward mb0">
          <Link onClick={browserHistory.goBack}>Về trang trước</Link>
        </div>
        <ConfirmDialog open={this.state.backConfirm} onClose={this.closeConfirmBack.bind(this)} onSuccess={this.handleBack.bind(this, true)}
          title={msg.confirmBack} />
        <ConfirmDialog open={this.state.openDialog} onClose={this.closeDialog.bind(this, 'openDialog')} onSuccess={this.exportExcel.bind(this, 'export')}
          title={msg.confirmExportExcel} />
        <ConfirmDialog open={this.state.popupChotBaoCao} onClose={this.closeDialog.bind(this, 'popupChotBaoCao')} onSuccess={this.chotBaoCao.bind(this, this.props.params.id)}
          title={`Số liệu báo cáo sẽ được chốt ngày ${ngayChot}`} />
        <div className="top-content">
          <div className="left-content">
            <ShowIf condition={this.state.thongTinBaoCao && this.state.thongTinBaoCao.kyBaoCao == 'THEO_QUY'}>
              <p className="title-18"><i className="tt tt-thongke"></i>{`Tổng hợp ${this.state.tenBaoCao ? this.state.tenBaoCao : ''} quý ${this.state.thongTinBaoCao ? this.state.thongTinBaoCao.quyBaoCao : ''} năm ${this.state.thongTinBaoCao ? this.state.thongTinBaoCao.namBaoCao : ''}`}</p>
            </ShowIf>
            <ShowIf condition={this.state.thongTinBaoCao && this.state.thongTinBaoCao.kyBaoCao == 'THEO_THANG'}>
              <p className="title-18"><i className="tt tt-thongke"></i>{`Tổng hợp ${this.state.tenBaoCao ? this.state.tenBaoCao : ''} tháng ${this.state.thongTinBaoCao ? this.state.thongTinBaoCao.thangBaoCao : ''} năm ${this.state.thongTinBaoCao ? this.state.thongTinBaoCao.namBaoCao : ''}`}</p>
            </ShowIf>
            <ShowIf condition={this.state.thongTinBaoCao && this.state.thongTinBaoCao.kyBaoCao != 'THEO_THANG' && this.state.thongTinBaoCao.kyBaoCao != 'THEO_QUY'}>
              <p className="title-18"><i className="tt tt-thongke"></i>{`Tổng hợp ${this.state.tenBaoCao ? this.state.tenBaoCao : ''} ${this.state.thongTinBaoCao ? this.state.thongTinBaoCao.kyBaoCaoText : ''} năm ${this.state.thongTinBaoCao ? this.state.thongTinBaoCao.namBaoCao : ''}`}</p>
            </ShowIf>
          </div>
        </div>
        <div className="bottom-content thongke-content">
          <div className='row pl10 pr10'>
            <h2 className='title-14 col-100 pt20 pl20 pr20'>1. Thông tin báo cáo</h2>
          </div>
          <div className='row pl25 pt10 pr25'>
            <Text className='col-100 mb10' label='Biểu mẫu:' value={this.state.tenBaoCao ? this.state.tenBaoCao : ''} />
            <Text className='col-25 mb10' label='Kỳ báo cáo:' value={this.state.thongTinBaoCao ? this.state.thongTinBaoCao.kyBaoCaoText : ''} />
            <Text className='col-25 mb10' label='Năm báo cáo:' value={this.state.thongTinBaoCao ? this.state.thongTinBaoCao.namBaoCao : ''} />
            <ShowIf condition={this.state.thongTinBaoCao && this.state.thongTinBaoCao.kyBaoCao == 'THEO_QUY'}>
              <Text className='col-25 mb10' label='Quý:' value={this.state.thongTinBaoCao ? this.state.thongTinBaoCao.quyBaoCao : ''} />
            </ShowIf>
            <ShowIf condition={this.state.thongTinBaoCao && this.state.thongTinBaoCao.kyBaoCao == 'THEO_THANG'}>
              <Text className='col-25 mb10' label='Tháng:' value={this.state.thongTinBaoCao ? this.state.thongTinBaoCao.thangBaoCao : ''} />
            </ShowIf>
          </div>
          <div className='row pl25 pr25'>
            <InputListDropDown
              label='Đơn vị'
              dataOption={this.state.dataOption}
              data={this.state.donViConsInfo}
              keyName='coQuanQuanLyId' valueName='ten'
              onChange={this.onChange.bind(this, 'donViConsInfo')}
              onAddItem={this.onAddItem.bind(this)}
              onRemoveItem={this.onRemoveItem.bind(this)}
            />
          </div>
          <div className='row pl15 pr15'>
            <div className='big-border'/>
          </div>
          <div className="wrap-table clear-left">
            <ShowIf condition={this.state.nameRowItem == 'KET_QUA_THANH_TRA_HANH_CHINH'} >
              <DataTable
                touchMove={true}
                addNew={!this.state.readOnly}
                addNewItem={this.addNewItem.bind(this)}
                header={header.thongKeBaoCaoThanhTraHanhChinh}
                dataList={this.state.data}
                exporttext="Xuất báo cáo"
                handleExport={this.exportExcel.bind(this)}
                hidePagination
                parent={this}
                hideExport={this.state.readOnly}
                hideButtonExport
                ThongKeBaoCao={true}
                LapBaoCao={true}
                numberColumnHeader={33}
                dataSum={this.state.dataSum}
                tableLoading={this.state.tableLoading}
                onChangeHeader={this.onChangeHeader.bind(this)}
              >
                <ListItemThongKeThanhTraHanhChinh onChange={this.onItemChange.bind(this)}/>
              </DataTable>
            </ShowIf>
            <ShowIf condition={this.state.nameRowItem == 'KET_QUA_THANH_TRA_TRONG_LINH_VUC_DAU_TU_XAY_DUNG_CO_BAN'} >
              <DataTable
                touchMove={true}
                addNew={!this.state.readOnly}
                addNewItem={this.addNewItem.bind(this)}
                header={header.thongKeBaoCaoThanhTraXayDungCoBan}
                dataList={this.state.data}
                exporttext="Xuất báo cáo"
                handleExport={this.exportExcel.bind(this)}
                hidePagination
                hideExport={this.state.readOnly}
                parent={this}
                hideButtonExport
                ThongKeBaoCao={true}
                LapBaoCao={true}
                numberColumnHeader={33}
                dataSum={this.state.dataSum}
                tableLoading={this.state.tableLoading}
                onChangeHeader={this.onChangeHeader.bind(this)}
              >
                <ListItemThongKeThanhTraXayDungCoBan onChange={this.onItemChange.bind(this)}/>
              </DataTable>
            </ShowIf>
            <ShowIf condition={this.state.nameRowItem == 'KET_QUA_THANH_TRA_TRONG_LINH_VUC_TAI_CHINH_NGAN_SACH'} >
              <DataTable
                touchMove={true}
                addNew={!this.state.readOnly}
                addNewItem={this.addNewItem.bind(this)}
                header={header.thongKeBaoCaoThanhTraTaiChinhNganSach}
                dataList={this.state.data}
                exporttext="Xuất báo cáo"
                handleExport={this.exportExcel.bind(this)}
                hidePagination
                parent={this}
                hideExport={this.state.readOnly}
                hideButtonExport
                ThongKeBaoCao={true}
                LapBaoCao={true}
                numberColumnHeader={27}
                dataSum={this.state.dataSum}
                tableLoading={this.state.tableLoading}
                onChangeHeader={this.onChangeHeader.bind(this)}
              >
                <ListItemThongKeThanhTraXayTaiChinhNganSach onChange={this.onItemChange.bind(this)}/>
              </DataTable>
            </ShowIf>
            <ShowIf condition={this.state.nameRowItem == 'KET_QUA_THANH_TRA_TRONG_LINH_VUC_DAT_DAI'} >
              <DataTable
                touchMove={true}
                addNew={!this.state.readOnly}
                addNewItem={this.addNewItem.bind(this)}
                header={header.thongKeBaoCaoThanhTraDatDai}
                dataList={this.state.data}
                exporttext="Xuất báo cáo"
                handleExport={this.exportExcel.bind(this)}
                hidePagination
                parent={this}
                hideExport={this.state.readOnly}
                hideButtonExport
                ThongKeBaoCao={true}
                LapBaoCao={true}
                numberColumnHeader={43}
                dataSum={this.state.dataSum}
                tableLoading={this.state.tableLoading}
                onChangeHeader={this.onChangeHeader.bind(this)}
              >
                <ListItemThongKeThanhTraDatDai onChange={this.onItemChange.bind(this)}/>
              </DataTable>
            </ShowIf>
            <ShowIf condition={this.state.nameRowItem == 'KET_QUA_THANH_TRA_LAI'} >
              <DataTable
                touchMove={true}
                addNew={!this.state.readOnly}
                addNewItem={this.addNewItem.bind(this)}
                header={header.thongKeBaoCaoThanhTraLai}
                dataList={this.state.data}
                exporttext="Xuất báo cáo"
                handleExport={this.exportExcel.bind(this)}
                hidePagination
                hideExport={this.state.readOnly}
                parent={this}
                hideButtonExport
                ThongKeBaoCao={true}
                LapBaoCao={true}
                numberColumnHeader={31}
                dataSum={this.state.dataSum}
                tableLoading={this.state.tableLoading}
                onChangeHeader={this.onChangeHeader.bind(this)}
              >
                <ListItemThongKeThanhTraLai onChange={this.onItemChange.bind(this)}/>
              </DataTable>
            </ShowIf>
            <ShowIf condition={this.state.nameRowItem == 'KET_QUA_THANH_TRA_KIEM_TRA_CHUYEN_NGANH'} >
              <DataTable
                touchMove={true}
                addNew={!this.state.readOnly}
                addNewItem={this.addNewItem.bind(this)}
                header={header.thongKeBaoCaoThanhTraChuyenNganh}
                dataList={this.state.data}
                exporttext="Xuất báo cáo"
                handleExport={this.exportExcel.bind(this)}
                hidePagination
                parent={this}
                hideExport={this.state.readOnly}
                hideButtonExport
                ThongKeBaoCao={true}
                LapBaoCao={true}
                numberColumnHeader={29}
                dataSum={this.state.dataSum}
                tableLoading={this.state.tableLoading}
                onChangeHeader={this.onChangeHeader.bind(this)}
              >
                <ListItemThongKeThanhTraChuyenNganh onChange={this.onItemChange.bind(this)}/>
              </DataTable>
            </ShowIf>
            <ShowIf condition={this.state.nameRowItem == 'KET_QUA_PHAT_HIEN_XU_LY_THAM_NHUNG_QUA_THANH_TRA'} >
              <DataTable
                touchMove={true}
                addNew={!this.state.readOnly}
                addNewItem={this.addNewItem.bind(this)}
                header={header.thongKeBaoCaoThanhTraThamNhung}
                dataList={this.state.data}
                exporttext="Xuất báo cáo"
                handleExport={this.exportExcel.bind(this)}
                hidePagination
                parent={this}
                hideButtonExport
                hideExport={this.state.readOnly}
                ThongKeBaoCao={true}
                LapBaoCao={true}
                numberColumnHeader={27}
                dataSum={this.state.dataSum}
                tableLoading={this.state.tableLoading}
                onChangeHeader={this.onChangeHeader.bind(this)}
              >
                <ListItemThongKeThanhTraThamNhung onChange={this.onItemChange.bind(this)}/>
              </DataTable>
            </ShowIf>
            <ShowIf condition={this.state.nameRowItem == 'CONG_TAC_QUAN_LY_NHA_NUOC_VE_THANH_TRA'} >
              <DataTable
                touchMove={true}
                addNew={!this.state.readOnly}
                addNewItem={this.addNewItem.bind(this)}
                header={header.nhaNuocVeThanhTra}
                dataList={this.state.data}
                exporttext="Xuất báo cáo"
                handleExport={this.exportExcel.bind(this)}
                hidePagination
                hideExport={this.state.readOnly}
                parent={this}
                hideButtonExport
                ThongKeBaoCao={true}
                LapBaoCao={true}
                numberColumnHeader={23}
                dataSum={this.state.dataSum}
                tableLoading={this.state.tableLoading}
                onChangeHeader={this.onChangeHeader.bind(this)}
              >
                <RowItemCongTacQuanLyNhaNuoc onChange={this.onItemChange.bind(this)}/>
              </DataTable>
            </ShowIf>
            <ShowIf condition={this.state.nameRowItem == 'CONG_TAC_XAY_DUNG_LUC_LUONG_THANH_TRA'} >
              <DataTable
                touchMove={true}
                addNew={!this.state.readOnly}
                addNewItem={this.addNewItem.bind(this)}
                header={header.xayDungLucLuongThanhTra}
                dataList={this.state.data}
                exporttext="Xuất báo cáo"
                handleExport={this.exportExcel.bind(this)}
                hidePagination
                parent={this}
                hideExport={this.state.readOnly}
                hideButtonExport
                ThongKeBaoCao={true}
                LapBaoCao={true}
                numberColumnHeader={26}
                dataSum={this.state.dataSum}
                tableLoading={this.state.tableLoading}
                onChangeHeader={this.onChangeHeader.bind(this)}
              >
                <RowItemXayDungLucLuongThanhTra onChange={this.onItemChange.bind(this)}/>
              </DataTable>
            </ShowIf>
            <ShowIf condition={this.state.nameRowItem == 'KET_QUA_TIEP_CONG_DAN'} >
              <DataTable
                touchMove={true}
                addNew={!this.state.readOnly}
                addNewItem={this.addNewItem.bind(this)}
                header={header.thongKeBaoCaoTiepCongDan}
                dataList={this.state.data}
                exporttext="Xuất báo cáo"
                handleExport={this.exportExcel.bind(this)}
                hidePagination
                hideExport={this.state.readOnly}
                parent={this}
                hideButtonExport
                ThongKeBaoCao={true}
                LapBaoCao={true}
                numberColumnHeader={37}
                dataSum={this.state.dataSum}
                tableLoading={this.state.tableLoading}
                onChangeHeader={this.onChangeHeader.bind(this)}
              >
                <ListItemThongKeTiepCongDan onChange={this.onItemChange.bind(this)}/>
              </DataTable>
            </ShowIf>
            <ShowIf condition={this.state.nameRowItem == 'KET_QUA_XU_LY_DON_KHIEU_NAI_TO_CAO'} >
              <DataTable
                touchMove={true}
                addNew={!this.state.readOnly}
                addNewItem={this.addNewItem.bind(this)}
                header={header.thongKeBaoCaoXuLyDon}
                dataList={this.state.data}
                exporttext="Xuất báo cáo"
                handleExport={this.exportExcel.bind(this)}
                hidePagination
                dataDonTrung={this.state.dataDonTrung}
                parent={this}
                hideButtonExport
                hideExport={this.state.readOnly}
                ThongKeBaoCao={true}
                LapBaoCao={true}
                numberColumnHeader={33}
                dataSum={this.state.dataSum}
                tableLoading={this.state.tableLoading}
                onChangeHeader={this.onChangeHeader.bind(this)}
                showTongDonTrung
              >
                <ListItemThongKeXuLyDon onChange={this.onItemChange.bind(this)}/>
              </DataTable>
            </ShowIf>
            <ShowIf condition={this.state.nameRowItem == 'KET_QUA_GIAI_QUYET_DON_KHIEU_NAI'} >
              <DataTable
                touchMove={true}
                addNew={!this.state.readOnly}
                addNewItem={this.addNewItem.bind(this)}
                header={header.thongKeBaoCaoGiaiQuyetDonKN}
                dataList={this.state.data}
                exporttext="Xuất báo cáo"
                handleExport={this.exportExcel.bind(this)}
                hidePagination
                hideExport={this.state.readOnly}
                parent={this}
                hideButtonExport
                ThongKeBaoCao={true}
                LapBaoCao={true}
                numberColumnHeader={40}
                dataSum={this.state.dataSum}
                tableLoading={this.state.tableLoading}
                onChangeHeader={this.onChangeHeader.bind(this)}
              >
                <ListItemThongKeGQDKN onChange={this.onItemChange.bind(this)}/>
              </DataTable>
            </ShowIf>
            <ShowIf condition={this.state.nameRowItem == 'KET_QUA_GIAI_QUYET_DON_TO_CAO'} >
              <DataTable
                touchMove={true}
                addNew={!this.state.readOnly}
                addNewItem={this.addNewItem.bind(this)}
                header={header.thongKeBaoCaoGiaiQuyetDonTC}
                dataList={this.state.data}
                exporttext="Xuất báo cáo"
                handleExport={this.exportExcel.bind(this)}
                hidePagination
                hideExport={this.state.readOnly}
                parent={this}
                hideButtonExport
                ThongKeBaoCao={true}
                LapBaoCao={true}
                numberColumnHeader={35}
                dataSum={this.state.dataSum}
                tableLoading={this.state.tableLoading}
                onChangeHeader={this.onChangeHeader.bind(this)}
              >
                <ListItemThongKeGQDTC onChange={this.onItemChange.bind(this)}/>
              </DataTable>
            </ShowIf>
            <ShowIf condition={this.state.nameRowItem == 'CONG_TAC_QUAN_LY_NHA_NUOC_VE_KHIEU_NAI_TO_CAO'} >
              <DataTable
                touchMove={true}
                addNew={!this.state.readOnly}
                addNewItem={this.addNewItem.bind(this)}
                header={header.quanLyNhaNuocVeKhieuNaiToCao}
                dataList={this.state.data}
                exporttext="Xuất báo cáo"
                handleExport={this.exportExcel.bind(this)}
                hidePagination
                hideExport={this.state.readOnly}
                parent={this}
                hideButtonExport
                ThongKeBaoCao={true}
                LapBaoCao={true}
                numberColumnHeader={19}
                dataSum={this.state.dataSum}
                tableLoading={this.state.tableLoading}
                onChangeHeader={this.onChangeHeader.bind(this)}
              >
                <RowItemCongTacQuanLyNhaNuocKNTC onChange={this.onItemChange.bind(this)}/>
              </DataTable>
            </ShowIf>
            <ShowIf condition={this.state.nameRowItem == 'KET_QUA_CHU_YEU_VE_CONG_TAC_PHONG_CHONG_THAM_NHUNG'} >
              <TableKetQuaPhongChongThamNhung
                touchMove={true}
                addNew={!this.state.readOnly}
                addNewItem={this.addNewItem.bind(this)}
                header={header.thongKeBaoCaoGiaiQuyetDonTC}
                dataList={this.state.data}
                exporttext="Xuất báo cáo"
                handleExport={this.exportExcel.bind(this)}
                hidePagination
                parent={this}
                hideExport={this.state.readOnly}
                hideButtonExport
                ThongKeBaoCao={true}
                LapBaoCao={true}
                numberColumnHeader={this.state.numberColumnHeader}
                dataSum={this.state.dataSum}
                tableLoading={this.state.tableLoading}
                pushData={this.reciveData.bind(this)}
                onChangeHeader={this.onChangeHeader.bind(this)}
              />
            </ShowIf>
            <ShowIf condition={this.state.nameRowItem == 'SO_LIEU_KE_KHAI_XAC_MINH_TAI_SAN'} >
              <DataTable
                touchMove={true}
                addNew={!this.state.readOnly}
                addNewItem={this.addNewItem.bind(this)}
                header={header.tongHopSoLieu}
                dataList={this.state.data}
                exporttext="Xuất báo cáo"
                handleExport={this.exportExcel.bind(this)}
                hidePagination
                hideExport={this.state.readOnly}
                parent={this}
                hideButtonExport
                ThongKeBaoCao={true}
                LapBaoCao={true}
                numberColumnHeader={12}
                dataSum={this.state.dataSum}
                tableLoading={this.state.tableLoading}
                onChangeHeader={this.onChangeHeader.bind(this)}
              >
                <RowItemTongHopKeKhai onChange={this.onItemChange.bind(this)}/>
              </DataTable>
            </ShowIf>
          </div>
          <div className='row pl15 pr15 pb15'>
            <span className='big-border'></span>
          </div>
          <ShowIf condition={this.state.showFile}>
            <div className='row pl30 pr30 '>
              <ContainerFileDinhKem label="3. Danh sách văn bản xử lý" labelClass="title-14" disableTopLine={true} bindValidator={this} dataShow={this.state.listTaiLieuVanThuShow} data={this.state.listTaiLieuVanThu} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)} disableAttachFile={this.state.readOnly} allowExcelFile={true}/>
            </div>
          </ShowIf>
        </div>
        <div className="pt30">
          <div className="box-bottom">
            <Button type="button" className="btn-action btn-close" onClick={ this.handleBack.bind(this, false) }><span>Đóng</span></Button>
            {
              !this.state.readOnly &&
              <Button type="button" className={`btn-action btn-save btn-green ${this.state.posting ? 'btn-loading-inline' : ''}`} onClick={this.guiBaoCao.bind(this, 'save')}>Lưu</Button>
            }
          </div>
        </div>
      </div>
    );
  }
}

LapBaoCaoDinhKyPage.defaultProps = {
  validators: {
    formTaoDon: []
  }
}

export default LapBaoCaoDinhKyPage;



// WEBPACK FOOTER //
// ./src/components/modules/bao-cao-dinh-ky/LapBaoCaoDinhKyPage.jsx